import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    InputWrapper: {
        marginBottom: "20px",
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "14px",
        lineHeight: "17px",
        color: "#271D1C",
        textTransform: "uppercase",

        "& .InputTitle": {
            marginTop: "4px",
            display: "flex",
        },
        "& .InputField": {
            position: "relative",
            flex: 5,
            marginRight: "0.5rem",
            "& input": {
                background: "#FFFFFF",
                border: "1px solid #e5e9f2",
                padding: "16px 46px",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "16px",
                lineHeight: "19px",
                // color: "rgba(110, 113, 135, 0.5)",
                display: "block",
                width: "100%",
                borderRadius: "8px",
            },
            "& i": {
                position: "absolute",
                top: "50%",
                left: "16px",
                transform: "translateY(-50%)",
                fontSize: "23px",
                color: "#6E7187",
            },
        },
    },
    Loading: {
        width: "1rem",
        height: "1rem",
    },
}));
